import React from "react";
import { connect } from "react-redux";
import { signout } from "../actions/auth";

const Header = props => {
  const { appName } = props.header;
  const { logout, authenticated } = props;

  if (!authenticated) return <div />;

  let organizationView;
  if (props.app.selectedAccount) {
    organizationView = (
      <span> {props.app.selectedAccount.organization_name} </span>
    );
  }

  const onLogout = e => {
    logout();
    e.preventDefault();
  };

  return (
    <div className="header">
      <div className="clearfix">
        <div className="pull-left"> {appName} </div>
        <div className="pull-right app-user">
          {" "}
          Kwesi
          {" "}
          {organizationView}
          {" "}
          |
          {" "}
          <a href="" onClick={onLogout}> Log out </a>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    logout() {
      dispatch(signout());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js